import { Wk8ReadService } from '@core/wk8/wk8-read.service';
import { Wk8TutorService } from '@core/wk8/wk8-tutor.service';
import { ILeesVariant } from '@features/wk8/mechanics/wk8-lees/variants/lees-variant.interface';
import { Wk8LeesComponent } from '@features/wk8/mechanics/wk8-lees/wk8-lees.component';
import { waitForMillis } from '@shared/delay.utils';

export class LeesFlitsenVariant implements ILeesVariant {
  private static readonly ZOEM_THRESHOLD = 500;

  readonly #ctx: {
    wk8TutorService: Wk8TutorService;
    wk8ReadService: Wk8ReadService;
  };
  private leesMechanic!: Wk8LeesComponent;

  private words: string[][] = [];
  private areMutations: boolean;
  private isDestroyed = false;
  private isZoemend: boolean | undefined = undefined;

  public constructor(
    words: string[][],
    areMutations: boolean,
    ctx: {
      wk8TutorService: Wk8TutorService;
      wk8ReadService: Wk8ReadService;
    },
  ) {
    this.#ctx = ctx;
    this.words = words;
    this.areMutations = areMutations;
  }

  public async init(leesMechanic: Wk8LeesComponent): Promise<void> {
    this.leesMechanic = leesMechanic;
  }

  private async setZoemen(zoemen: boolean) {
    if (this.isZoemend === zoemen) return;

    this.isZoemend = zoemen;
    await this.#ctx.wk8TutorService.showMechanic(zoemen ? 'lees_woord_zoemend' : 'lees_woord');
  }

  public async start(): Promise<void> {
    for (let i = 0; i < this.words.length; i++) {
      let timePerKlank = await this.#ctx.wk8ReadService.getReadSpeed();

      await Promise.all([
        ...(timePerKlank >= LeesFlitsenVariant.ZOEM_THRESHOLD
          ? [
              this.leesMechanic.condense(false), //
            ]
          : [this.leesMechanic.condense(true)]),
        this.leesMechanic.unhighlight(),
      ]);
      await this.leesMechanic.showMetronome(true);
      await this.leesMechanic.setWord(this.words[i], this.areMutations);

      while (true) {
        timePerKlank = await this.#ctx.wk8ReadService.getReadSpeed();
        await this.setZoemen(timePerKlank >= LeesFlitsenVariant.ZOEM_THRESHOLD);

        await Promise.all([
          this.leesMechanic.condense(!this.isZoemend), //
          this.leesMechanic.unhighlight(),
        ]);

        await this.leesMechanic.readPass(timePerKlank);

        if (this.isZoemend) {
          await Promise.all([
            this.leesMechanic.condense(true), //
            this.leesMechanic.showMetronome(false),
            this.leesMechanic.unhighlight(),
          ]);

          await waitForMillis(200); // extra delay
          await this.leesMechanic.readPass(50);
        } else {
          await Promise.all([
            this.leesMechanic.showMetronome(false), //
          ]);
        }

        if (this.isDestroyed) return;

        const choice = await this.#ctx.wk8TutorService.waitForChoice('herstart trager', 'verder');
        if (choice === 'verder') {
          await this.#ctx.wk8ReadService.updateReadSpeed(true);
          break;
        }

        await this.#ctx.wk8ReadService.updateReadSpeed(false);
      }
    }
    this.leesMechanic.finish();
  }

  public async stop(): Promise<void> {
    this.isDestroyed = true;
  }
}
